import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "@op/opds.opux-modal";
import { Button, ButtonRow } from "@op/opds.opux";
import { useMessage, Message, useMessageGetter } from "react-message-context";
import { withRouter } from "react-router-dom";

const QuitAction = ({ isSending, history }) => {
  const [open, setOpen] = useState(false);

  const modalMsgs = useMessageGetter("feedback.form.quit.modal");
  const link = useMessage("url.quit")();

  const renderFooter = () => (
    <ButtonRow className="cff-modal__footer">
      <Button id="CFF-cancelQuitButton" compact onClick={() => setOpen(!open)}>
        {modalMsgs("button.cancel")}
      </Button>
      <Button id="CFF-quitButton" compact onClick={() => history.push(link)}>
        {modalMsgs("button.quit")}
      </Button>
    </ButtonRow>
  );

  const handleAction = (e, isKeyPress) => {
    e.preventDefault();
    if (!isKeyPress || (isKeyPress && (e.key === "Enter" || e.key === " "))) {
      setOpen(!open);
    }
  };

  return (
    <>
      <Button
        id="CFF-quitAction"
        className="skip-link-interruption"
        alternate
        nonInteractive={isSending}
        onClick={(e) => handleAction(e, false)}
        onKeyPress={(e) => handleAction(e, true)}
      >
        <Message id="feedback.form.quit.button" />
      </Button>
      <Modal
        id="CFF-quitModal"
        className="cff-modal"
        appElement={document.getElementById("customerfeedbackopfi-main")}
        footer={renderFooter()}
        onUpdate={(state) => setOpen(state.open)}
        title={modalMsgs("title")}
        isOpen={open}
      >
        <div className="opux-v6__opds">
          <p>{modalMsgs("body")}</p>
        </div>
      </Modal>
    </>
  );
};

QuitAction.propTypes = {
  isSending: PropTypes.bool,
};

export default withRouter(QuitAction);
